import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { createContext, useState } from 'react';
import { AI_STUDENT_FEEDBACK_URL } from 'utils/constants';
import { uploadFile } from 'utils/file';
import { getChatCompletion } from 'utils/helper';
import { v4 as uuid } from 'uuid';

const PageContext = createContext();

const PageProvider = (props) => {
    const { course, currentAssignment, setBatch } = useApp();
    const { auth } = useAuth();

    const [uploadAssignmentsDialog, setUploadAssignmentsDialog] = useState({ open: false });

    const createSubmissions = async (submissions) => {
        const timestamp = new Date().getTime();
        const id = uuid();
        const [platform] = process.env.REACT_APP_API_ENDPOINT.split('/').slice(-1);

        const batch = {
            id,
            active: true,
            created_on: timestamp,
            modified_on: timestamp,
            owner_account_id: auth.id,
            course_id: course.id,
            assignment_id: currentAssignment.id,
            submissions,
            is_rag_ready: currentAssignment.is_rag_ready || false,
            is_finished: false,
            assignment_data: currentAssignment,
            content_bank_resources: currentAssignment.content_bank_resources || [],
            platform,
        };
        setBatch((current) => [...(current || []), batch]);
        const blob = new Blob([JSON.stringify(batch)], { type: 'application/json' });
        const fileName = 'AI_STUDENT_FEEDBACK.json';
        const JSONFile = new File([blob], fileName, { type: 'application/json' });

        const file = await new Promise(async (resolve, reject) => {
            await uploadFile(
                JSONFile,
                () => {},
                (data) => {
                    resolve(data);
                },
                (error) => {
                    console.error(error);
                    reject(error);
                },
                auth.owner_account_id
            );
        });
        await getChatCompletion(AI_STUDENT_FEEDBACK_URL, JSON.stringify(file));
    };

    return (
        <PageContext.Provider
            value={{
                uploadAssignmentsDialog,
                setUploadAssignmentsDialog,
                createSubmissions,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
